import React, { useMemo, useState, useRef } from 'react';
import { ArrowPathIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const HangfirePage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const hangfireUrl = useMemo(() => {
    const apiRoot = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/api\/?$/, '');
    const token = sessionStorage.getItem('@KnowInDoc:accessToken') ?? '';
    return `${apiRoot}/admin/hangfire?access_token=${encodeURIComponent(token)}`;
  }, []);

  const handleIframeLoad = () => {
    setIsLoading(false);
    setHasError(false);
  };

  const handleIframeError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  const retryLoad = () => {
    setIsLoading(true);
    setHasError(false);
    if (iframeRef.current) {
      iframeRef.current.src = iframeRef.current.src;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                     <div className="px-6 py-4 border-b border-gray-200">
                       <div>
                         <h3 className="text-lg font-medium text-gray-900">
                           Painel de monitoramento
                         </h3>
                         <p className="text-sm text-gray-500">
                           Controle de tarefas recorrentes do sistema
                         </p>
                       </div>
                     </div>
            
            <div className="relative" style={{ height: 'calc(100vh - 200px)' }}>
              {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-gray-50 z-10">
                  <div className="text-center">
                    <ArrowPathIcon className="h-8 w-8 animate-spin mx-auto text-indigo-600 mb-2" />
                    <p className="text-sm text-gray-600">Carregando Hangfire Dashboard...</p>
                  </div>
                </div>
              )}

              {hasError && (
                <div className="absolute inset-0 flex items-center justify-center bg-gray-50 z-10">
                  <div className="text-center">
                    <ExclamationTriangleIcon className="h-12 w-12 text-red-500 mx-auto mb-4" />
                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                      Erro ao Carregar Hangfire
                    </h3>
                    <p className="text-sm text-gray-500 mb-4">
                      Não foi possível carregar o dashboard do Hangfire
                    </p>
                    <button
                      onClick={retryLoad}
                      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      <ArrowPathIcon className="h-4 w-4 mr-2" />
                      Tentar Novamente
                    </button>
                  </div>
                </div>
              )}

              <iframe
                ref={iframeRef}
                src={hangfireUrl}
                className="w-full h-full border-0"
                title="Hangfire Dashboard"
                onLoad={handleIframeLoad}
                onError={handleIframeError}
                sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
                style={{ minHeight: '600px' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HangfirePage;
